import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyDToJDoCVvcGP8hYg5sIgxABJtRgAs3lNQ',
  authDomain: 'konekto-d193a.firebaseapp.com',
  projectId: 'konekto-d193a',
  storageBucket: 'konekto-d193a.firebasestorage.app',
  messagingSenderId: '743975025560',
  appId: '1:743975025560:web:b55589c8c60e77144d09ed',
  measurementId: 'G-CGW241MQQ4',
}

const app = initializeApp(firebaseConfig)
export const analytics = getAnalytics(app)

export default app
